import { render, staticRenderFns } from "./smsList.vue?vue&type=template&id=49c8b42a&"
import script from "./smsList.vue?vue&type=script&lang=js&"
export * from "./smsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports